/* eslint-disable import/prefer-default-export */
/* eslint no-underscore-dangle: "off" */
// Initialize the all directives

export const loading = {
	bind (el, binding) {
		el.__innerHTML__ = el.innerHTML
		const a = binding.value instanceof Promise
		if (a) {
			el.innerHTML =
        `${el.__innerHTML__} <i class="fa fa-circle-o-notch fa-pulse fa-fw"></i>`
			el.disabled = true
		}
	},
	unbind (el) {
		el.__innerHTML__ = null
		el.innerHTML = el.__innerHTML__
		el.disabled = false
	},
	update (el, binding) {
		const a = binding.value instanceof Promise
		if (a) {
			el.innerHTML =
        `${el.__innerHTML__} <i class="fas fa-spinner"></i>`
			el.disabled = true
			binding.value.finally(() => {
				el.innerHTML = el.__innerHTML__
				el.disabled = false
			})
		}
	}
}
